import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  employees: [],
  isLoading: false,
  employeeSuggestions: [],
  employeeIsDragging: null
}


export default (state=initState, action) => {
  switch (action.type) {
    case actionConsts.DEPARTMENT_GET_EMPLOYEES_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
    });
    case actionConsts.DEPARTMENT_GET_EMPLOYEES_SUCCESS:
      return update(state, {
        isLoading: {
          $set: false
        },
        employees: {
          $set: action.employees
        }
    });
    case actionConsts.DEPARTMENT_GET_EMPLOYEES_FAILURE:
      return update(state, {
        isLoading: {
          $set: false
        }
    });
    case actionConsts.GET_EMPLOYEE_SUGGESTIONS_SUCCESS:
      return update(state, {
        employeeSuggestions: {
          $set: action.suggestions
        }
    });
    case actionConsts.DEPARTMENT_ADD_EMPLOYEE_REQUEST:
      return update(state, {
        employees: {
          $splice: [[0,0,action.employee]]
        }
    });
    case actionConsts.DEPARTMENT_ADD_EMPLOYEE_SUCCESS:
      return update(state, {
        employees: {
          0:{
            initials: {
              $set: action.employeeInitials
            }
          }
        }
    });
    case actionConsts.REMOVE_EMPLOYEE_FROM_DEPARTMENT:
      return update(state, {
        employees: {
          $splice: [[action.employeeIndex,1]]
        }
    });
    case actionConsts.SET_EMPLOYEE_IS_DRAGGING:
      return update(state, {
        employeeIsDragging: {
          $set: action.employeeId
        }
    });
    case actionConsts.DEPARTMENT_MOVE_EMPLOYEE_REQUEST:
    case actionConsts.DEPARTMENT_MOVE_EMPLOYEE_FAILURE:
      return update(state, {
        employees: {
          $set: action.employees
        }
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/EmployeeListView/reducer.jsx